import { render } from "./DashboardAlarmStatusSummary.vue?vue&type=template&id=1b2b0742"
import script from "./DashboardAlarmStatusSummary.vue?vue&type=script&lang=js"
export * from "./DashboardAlarmStatusSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__